






import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

@Component({
})
export default class AppLoader extends Vue {
  @Prop({ type: Number, default: 1 }) readonly currentPage!: number
  @Prop({ type: Number, default: 6 }) readonly length!: number

  current = 1

  @Emit('change')
  onChange (item: number) {
    this.current = item
    return item
  }

  @Watch('currentPage')
  currentPageChanged (val: number) {
    this.current = val
  }
}
